<template>
  <div class="page-container">
    <div class="data-filter">
        <el-button size="mini" type="primary" :loading="server.loading" @click="serverListSave">저장하기</el-button>
    </div>
    <div class="data-table">
        <el-form ref="serverenable" :model="server.form" :rules="server.rules">
            <el-table class="lmm-table" :data="list" v-loading="loading" stripe border>
                <el-table-column type="index" :index="rowIndex" width="100"></el-table-column>
                <el-table-column label="서버명" width="200">
                  <template slot-scope="scope">
                      {{scope.row.memo}}
                  </template>
                </el-table-column>
                <el-table-column label="IP" width="300">
                  <template slot-scope="scope" prop="address">
                    <el-input v-model="scope.row.address"></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="Port">
                  <template slot-scope="scope" prop="port">
                    <el-input v-model="scope.row.port"></el-input>
                  </template>
                </el-table-column>
            </el-table>
        </el-form>
    </div>
  </div>
</template>

<script>
export default {
    methods: {
        async getServerList () {
          console.log('GET SERVER_LIST')

          try {
            this.loading = true

            let response = await this.$http.get('server_list')
            this.list = response.data

            this.loading = false

            return response
          }
          catch (e) {
            console.error(e)
          }
        },
        rowIndex (index) {
          return index + 1
        },
        async serverListSave () {
          this.server.form = this.list[0]
          
          for (var i = 0; i < 5; i++) {
            let {status} = await this.$http.post('server_list', this.list[i])
            if (status === 200) {
              this.$service.$emit('alert-modal', '서버정보가 수정되었습니다.')
            }else{
              console.log(e)
            }
          }

        }
    },
    mounted () {
      this.getServerList()
    },
    data () {
        return {
            loading: false,
            dialog_notice: false,
            dialog_notice_option: null,
            list: [],
            server: {
              loading: false,
              rules: {
                // address: [
                //   {validator: (r, v, cb) => { if (!v) cb(new Error('IP주소를 입력해 주세요')); else cb(); }},
                //   {validator: (r, v, cb) => { if (!/^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$/.test(v)) cb(new Error('올바른 IP주소를 입력해주세요')); else cb() }}
                // ],
                // port: [
                //   {validator: (r, v, cb) => { if (!v) cb(new Error('IP주소를 입력해 주세요')); else cb(); }},
                //   {validator: (r, v, cb) => { if (!/^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$/.test(v)) cb(new Error('올바른 IP주소를 입력해주세요')); else cb() }}
                // ]
                test: {
                  address: [
                    {validator: (r, v, cb) => { if (!v) cb(new Error('IP주소를 입력해 주세요')); else cb(); }},
                    {validator: (r, v, cb) => { if (!/^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$/.test(v)) cb(new Error('올바른 IP주소를 입력해주세요')); else cb() }}
                  ],
                  port: [
                    {validator: (r, v, cb) => { if (!v) cb(new Error('IP주소를 입력해 주세요')); else cb(); }},
                    {validator: (r, v, cb) => { if (!/^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$/.test(v)) cb(new Error('올바른 IP주소를 입력해주세요')); else cb() }}
                  ]
                },
                kms: {
                  address: [
                    {validator: (r, v, cb) => { if (!v) cb(new Error('IP주소를 입력해 주세요')); else cb(); }},
                    {validator: (r, v, cb) => { if (!/^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$/.test(v)) cb(new Error('올바른 IP주소를 입력해주세요')); else cb() }}
                  ],
                  port: [
                    {validator: (r, v, cb) => { if (!v) cb(new Error('IP주소를 입력해 주세요')); else cb(); }},
                    {validator: (r, v, cb) => { if (!/^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$/.test(v)) cb(new Error('올바른 IP주소를 입력해주세요')); else cb() }}
                  ]
                },
                ap2p: {
                  address: [
                    {validator: (r, v, cb) => { if (!v) cb(new Error('IP주소를 입력해 주세요')); else cb(); }},
                    {validator: (r, v, cb) => { if (!/^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$/.test(v)) cb(new Error('올바른 IP주소를 입력해주세요')); else cb() }}
                  ],
                  port: [
                    {validator: (r, v, cb) => { if (!v) cb(new Error('IP주소를 입력해 주세요')); else cb(); }},
                    {validator: (r, v, cb) => { if (!/^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$/.test(v)) cb(new Error('올바른 IP주소를 입력해주세요')); else cb() }}
                  ]
                },
                capi: {
                  address: [
                    {validator: (r, v, cb) => { if (!v) cb(new Error('IP주소를 입력해 주세요')); else cb(); }},
                    {validator: (r, v, cb) => { if (!/^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$/.test(v)) cb(new Error('올바른 IP주소를 입력해주세요')); else cb() }}
                  ],
                  port: [
                    {validator: (r, v, cb) => { if (!v) cb(new Error('IP주소를 입력해 주세요')); else cb(); }},
                    {validator: (r, v, cb) => { if (!/^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$/.test(v)) cb(new Error('올바른 IP주소를 입력해주세요')); else cb() }}
                  ]
                },
                flask: {
                  address: [
                    {validator: (r, v, cb) => { if (!v) cb(new Error('IP주소를 입력해 주세요')); else cb(); }},
                    {validator: (r, v, cb) => { if (!/^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$/.test(v)) cb(new Error('올바른 IP주소를 입력해주세요')); else cb() }}
                  ],
                  port: [
                    {validator: (r, v, cb) => { if (!v) cb(new Error('IP주소를 입력해 주세요')); else cb(); }},
                    {validator: (r, v, cb) => { if (!/^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$/.test(v)) cb(new Error('올바른 IP주소를 입력해주세요')); else cb() }}
                  ]
                }
              },
              form: {
                // address: '',
                // port: '',
                test: {
                  address: '',
                  port: ''
                },
                kms: {
                  address: '',
                  port: ''
                },
                ap2p: {
                  address: '',
                  port: ''
                },
                capi: {
                  address: '',
                  port: ''
                },
                flask: {
                  address: '',
                  port: ''
                }
              }
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.data-filter {
  padding: 10px 0;
  .data-filter-buttons {
    display: inline-block;
  }
  .data-filter-search {
    display: inline-block;
    padding-left: 15px;
  }
}
</style>